import { trpc } from "@/lib/trpc";
import { toast } from "sonner";
import { fromError } from "zod-validation-error";

export const useCreateAuthProviderMutation = (
    setLoading?: (loading: boolean) => void,
    setError?: (error: string) => void
) => {
    const utils = trpc.useUtils();
    return trpc.authProviders.create.useMutation({
        onMutate: async () => {
            setLoading?.(true);
            setError?.("");
        },
        onSuccess: async () => {
            utils.authProviders.findAll.invalidate();
            utils.authProviders.findEnabled.invalidate();
            utils.settings.findOne.invalidate();
            toast.success("Auth provider created successfully");
        },
        onError: async (error: any) => {
            const errorMessage = fromError(error).toString();
            toast.error(errorMessage);
            setError?.(errorMessage);
        },
        onSettled: async () => {
            setLoading?.(false);
        },
    });
};

export const useUpdateAuthProviderMutation = (
    setLoading?: (loading: boolean) => void,
    setError?: (error: string) => void
) => {
    const utils = trpc.useUtils();
    return trpc.authProviders.update.useMutation({
        onMutate: async () => {
            setLoading?.(true);
            setError?.("");
        },
        onSuccess: async (data) => {
            utils.authProviders.findAll.invalidate();
            utils.authProviders.findEnabled.invalidate();
            utils.authProviders.findById.invalidate({ id: data.id });
            utils.authProviders.findByProvider.invalidate({ provider: data.provider });
            utils.settings.findOne.invalidate();
            toast.success("Auth provider updated successfully");
        },
        onError: async (error: any) => {
            const errorMessage = fromError(error).toString();
            toast.error(errorMessage);
            setError?.(errorMessage);
        },
        onSettled: async () => {
            setLoading?.(false);
        },
    });
};

export const useSetEnabledAuthProviderMutation = () => {
    const utils = trpc.useUtils();
    return trpc.authProviders.setEnabled.useMutation({
        onSuccess: async (data) => {
            utils.authProviders.findAll.invalidate();
            utils.authProviders.findEnabled.invalidate();
            utils.settings.findOne.invalidate();
            toast.success(`Auth provider ${data.enabled ? "enabled" : "disabled"} successfully`);
        },
        onError: async (error: any) => {
            const errorMessage = fromError(error).toString();
            toast.error(errorMessage);
        },
    });
};

export const useDeleteAuthProviderMutation = () => {
    const utils = trpc.useUtils();
    return trpc.authProviders.delete.useMutation({
        onSuccess: async () => {
            utils.authProviders.findAll.invalidate();
            utils.authProviders.findEnabled.invalidate();
            utils.settings.findOne.invalidate();
            toast.success("Auth provider deleted successfully");
        },
        onError: async (error: any) => {
            const errorMessage = fromError(error).toString();
            toast.error(errorMessage);
        },
    });
};
